import React, { useState, useEffect, useRef,useCallback } from 'react';
import MainImageLogo from './MainImageLogo';
import HeaderLogo from './HeaderLogo';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { hideComponents } from '../store';
import AudioToText from './backend/AudioToText';
import AudioToTextJavaScript from './backend/AudioToTextJavaScript';

import FaceDetection from './backend/FaceDetection';
import VoiceDetection from './backend/VoiceDetection';
import UseToast from './UseToast';
import { UseTranslationData } from './UseTranslationData';
//import video from '../assets/videos/4k.mp4';
import { format, toZonedTime } from 'date-fns-tz';
import { parse } from 'date-fns'; // Import parse from date-fns
import axios from 'axios';
import BubblesIntegration from './BubblesIntegration';
import SplashTextAIHuman from './backend/buttonApp/SplashTextAIHuman';
import WebSocketIframe from './WebSocketIframe';
import {
  SessionState,
} from "@heygen/liveavatar-web-sdk";

import { useSessionState } from '../hooks/useSessionState';
import { useWebSocketControl } from '../hooks/useWebSocketControl';

export default function AiFormUpdateProd() {
  const [aiFormData, setAIFormData] = useState(null);
  const [userBrandSettings, setUserBrandSettings] = useState(null)
  const [translationData, setTranslationData] = useState(null);
  const [defaultLang, setDefaultLang] = useState(localStorage.getItem('default_lang') || 'en');
  const [siteBrandColor, setSiteBrandColor] = useState('');
  const [languages, setLanguages] = useState([]);
  const [sessionInfo, setSessionInfo] = useState({});
  const mediaRef = useRef(null); // Reference to the media element

  const rizwanScriptStepRef = useRef(null);
  const rizwanScriptStepEnglishRef = useRef(null);
  const [startSpeech, setStartSpeech] = useState(false);

  const { avtarsesssion } = useSelector(state => state.visibility);

  const [rizwanScriptStep, setRizwanScriptStep] = useState(1);

  const { showWarningToast, dismissToast } = UseToast(); // Use the custom hook

  const [isAvatarVisible, setIsAvatarVisible] = useState(false); // State to manage visibility

  const numberRef = useRef([]); // Initialize useRef with an empty array

  const [loaderStart, setLoaderStart] = useState(false);

  const [showButton, setShowButton] = useState(false);

  const [faceDetectionStartSpeech, setFaceDetectionStartSpeech] = useState(false);

  const isInRangeRef = useRef(false); // Create a ref to hold isInRange value
  const [idealMode, setIdealMode] = useState(false);
  const [isTimeRange, setIsTimeRange] = useState(false);

  const [waitingTime, setWaitingTime] = useState(false);

  const videoRef = useRef(null);
  const isTimeRangeRef = useRef(null);
  const timeoutIdRef = useRef(null); // To store the timeout ID

  const resetCameraRef = useRef(null); // To store the timeout ID
  const [key, setKey] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false); // Tracks if the user was offline
  const disconnectTimer = useRef(null);

  const { client_url } = useParams();
  const dispatch = useDispatch();
  const [loopingVideoUrl, setLoopingVideoUrl] = useState('');
  const [beforeAvatarVideo, setBeforeAvatarVideo] = useState("hello");


  const [disableSpeechButton, setDisableSpeechButton] = useState(false);
  const disableSpeechButtonRef = useRef(null);
  const [startAutoButtonSpeech, setStartAutoButtonSpeech] = useState(false);
  const startAutoButtonSpeechRef = useRef(null);

  const [heygenVideoQuality, setHeygenVideoQuality] = useState(false);

  const [skipSplashScreen, setSkipSplashScreen] = useState(false);
  const [isStreamReadyState, setIsStreamReadyState] = useState(false);
  const mediaStreamStartedRef = useRef(false);

  const [streamTimeoutMinutes, setStreamTimeoutMinutes] = useState(10);

  // WebSocket configuration state
  const [websocketEnabled, setWebsocketEnabled] = useState(false);
  const [aiHumanWebsocketUrl, setAiHumanWebsocketUrl] = useState('');
  const [iframeStyles, setIframeStyles] = useState({
    bottom: 20,
    left: 50,
    right: null,
    width: 800,
    height: 500,
    padding: 12,
    borderRadius: 16,
    borderWidth: 4,
    zIndex: 1000
  });


  const avatarSessionRef = useRef(null);
  const inactivityTimerRef = useRef(null);
  const lastTalkingRef = useRef(Date.now());

  const ranOnceRef = useRef(false)



  const {
    sessionState,
    isStreamReady,
    startSession,
    stopSession,
    attachElement,
    sessionRef,
    isAvatarTalking
  } = useSessionState();

  // Create a ref to hold the repeat function so it can be passed to useWebSocketControl
  // before it's defined (solves hoisting issue)
  const repeatRef = useRef(null);

  // Initialize WebSocket control hook for remote avatar control
  // This enables third-party systems to control the avatar via WebSocket commands
  // while maintaining backward compatibility with existing UI controls
  const { wsControlEnabled, emitStateChange, emitVideoMode } = useWebSocketControl(
    sessionInfo,
    aiFormData,
    repeatRef,
    sessionRef,
    isAvatarTalking,
    setDefaultLang,
    sessionState
  );

  const attachedRef = useRef(false);
  const stoppingRef = useRef(false);
  const initialVideoRef = useRef(null); // splash / before avatar
  const loopVideoRef = useRef(null);    // idle looping video



  const VIDEO_MODE = {
    INITIAL: "INITIAL",
    LOOP: "LOOP",
    STREAM: "STREAM",
  };

  const [mode, setMode] = useState(VIDEO_MODE.INITIAL);


  const streamActivatedRef = useRef(false);



  useEffect(() => {
    disableSpeechButtonRef.current = disableSpeechButton;
  }, [disableSpeechButton])

  useEffect(() => {
    startAutoButtonSpeechRef.current = startAutoButtonSpeech;

  }, [startAutoButtonSpeech])

  useEffect(() => {

    setDisableSpeechButton(isAvatarTalking);

  }, [isAvatarTalking]);

  const handleReconnect = async () => {
    console.log('Reconnected to the internet! Performing actions...');

    // Dismiss the toast or perform other actions
    dismissToast();

    // Reload the page after 2-3 seconds
    setTimeout(async () => {
      await recordLog(
        'Reconnected to the internet!',
        'Reconnected to the internet!',
        'pending',
        'non-rizwan'
      );
      window.location.reload();
    }, 5000); // 2000 milliseconds = 2 seconds
  };

  const updateOnlineStatus = async () => {
    if (navigator.onLine) {
      // Clear the disconnect timer and handle reconnection
      clearTimeout(disconnectTimer.current);
      setIsOnline(true);

      if (wasOffline) {
        handleReconnect(); // Call the function when transitioning to online
        setWasOffline(false); // Reset offline flag
      }
    } else {
      //await recordLog('Disconnected from the internet!','Disconnected from the internet!','pending','non-rizwan');

      // Wait for 30 seconds before marking as offline
      disconnectTimer.current = setTimeout(async () => {
        setIsOnline(false);
        setWasOffline(true); // Mark as offline
        console.log('Disconnected from the internet!');
        showWarningToast(
          'Sorry, we are experiencing temporary technical difficulties. please come back in a few minutes.'
        );
      }, 5000); // 30,000 milliseconds = 30 seconds
    }
  };

  useEffect(() => {
    // Add event listeners for online and offline events
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      clearTimeout(disconnectTimer.current);
    };
  }, [wasOffline]); // Dependency ensures updates when `wasOffline` changes

  useEffect(() => {
    rizwanScriptStepRef.current = rizwanScriptStep;

    if (rizwanScriptStep !== 2) {
      rizwanScriptStepEnglishRef.current = null;
    }
  }, [rizwanScriptStep]);

  useEffect(() => {
    const getColor = async () => {
      try {
        const response = await fetch(`/auth/aiform/frontend/${client_url}`);

        const data = await response.json();
        if (!response.ok) {
          alert(`Error: ${data.message}`);
        } else {
          const aiForm = data.aiForms[0];
          const user = data.user;

          await fetchVideoQuality(aiForm);
          setAIFormData(aiForm);
          setUserBrandSettings(data.user);

          const translation = UseTranslationData(aiForm, defaultLang);
          setTranslationData(translation);

          setStreamTimeoutMinutes(aiForm?.stream_timeout_minutes || 10);

          // if (translation) {
          //   setSiteBrandColor(translation.site_brand_color);
          //   localStorage.setItem('site_brand_color', translation.site_brand_color);
          // }


          setSiteBrandColor(user?.brandColor);
          localStorage.setItem('site_brand_color', user?.brandColor);

          // Set languages
          setLanguages(aiForm.selected_lang_values);

          // Fetch WebSocket configuration
          try {
            const wsResponse = await fetch(`/api/websocket-config/${user._id}`);
            const wsData = await wsResponse.json();
            if (wsData.success && wsData.config) {
              setWebsocketEnabled(wsData.config.enabled);
              setAiHumanWebsocketUrl(wsData.config.aiHumanWebsocketUrl || '');
              setIframeStyles(wsData.config.iframeStyles || {
                bottom: 20,
                left: 50,
                right: null,
                width: 800,
                height: 500,
                padding: 12,
                borderRadius: 16,
                borderWidth: 4,
                zIndex: 1000
              });
            }
          } catch (wsError) {
            console.log('WebSocket config not found:', wsError);
          }

          // Position the avatar logo
          // positionAvatarLogo(aiForm.avtar_page_image_location);

          // Handle live chat visibility
          handleLiveChatVisibility(aiForm, translation);

          setTimeout(() => {
            setShowButton(true);
          }, aiForm?.time_rane_splash * 1000); // 5 seconds
        }
      } catch (error) {
        console.error('Error fetching AI form data:', error);
      }
    };

    getColor();
    dispatch(hideComponents({ showHeader: false, showSidebar: false }));

    // dispatch(hideComponents());
  }, [defaultLang, dispatch]);

  const fetchVideoQuality = async (aiData) => {
    const keyId = aiData?.heygen_api_key_id;
    try {
      if (keyId) {
        const res = await fetch(`/api/api-keys/heygen-key/${keyId}`);
        const data = await res.json();
        const heygenKeyId = data?.data?.enableHighQuality;
        setHeygenVideoQuality(heygenKeyId);
      } else {
        setHeygenVideoQuality(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const positionAvatarLogo = location => {
    let style = {};
    switch (location) {
      case 'top-right':
        style = { top: '0px', right: '5px' };
        break;
      case 'top-left':
        style = { top: '0px', left: '5px' };
        break;
      case 'bottom-right':
        style = { bottom: '0px', right: '5px' };
        break;
      case 'bottom-left':
        style = { bottom: '0px', left: '5px' };
        break;
      default:
        break;
    }
    return style;
  };

  const handleLiveChatVisibility = (aiForm, translation) => {
    if (aiForm.live_chat_enable === 'yes') {
      return (
        <>
          <a
            href={translation?.live_chat_url}
            style={{
              display: 'block',
              backgroundColor: translation?.site_brand_color,
              fontWeight: 'bold',
            }}
            target={aiForm.open_chat_new_tab === 'yes' ? '_blank' : '_self'}
            id="ai_live_chat"
            rel="noreferrer"
          >
            {translation?.live_chat_button_text}
          </a>
        </>
      );
    }
    return null;
  };

  const handleLanguageChange = lang => {
    localStorage.setItem('default_lang', lang);
    setDefaultLang(lang);
  };

  const renderLanguageButtons = () => {
    return languages?.map(item => (
      <div key={item.value} className={`${item.value}_language_sec language_btn`}>
        <button
          type="button"
          className={item.value === defaultLang ? 'current_lang' : ''}
          style={{
            backgroundColor: item.value === defaultLang ? siteBrandColor : '#fff',
            border: `1px solid ${siteBrandColor}`,
            color: item.value === defaultLang ? '#fff' : siteBrandColor,
          }}
          onClick={() => handleLanguageChange(item.value)}
        >
          {item.title}
        </button>
      </div>
    ));
  };


  useEffect(() => {
    if (!aiFormData?.avtar_key || !aiFormData?.voice_key) {
      return;
    }

    const intervalId = setInterval(() => {
      checkTime();
    }, 60000);

    if (aiFormData?.weeklyTiming) {
      const checkTime = filterCurrentDayAndCheckTime(aiFormData?.weeklyTiming, aiFormData?.timezone);



      if (!checkTime) {
        return;
      } else {
        setIsTimeRange(true);
      }
    }

    const checkLoop = getLoopSessionData(client_url);

    if (checkLoop && checkLoop.idealMode) {
      setIdealMode(true);
      setSkipSplashScreen(true);
      videoRef.current = true;
      setIsAvatarVisible(true);
      scheduleFollowUp();
      setDisableSpeechButton(false);
      //disableSpeechButtonRef.current = false;
      return;
    }
    if (aiFormData.enable_rizwan_event !== 'yes' && (localStorage.getItem(client_url) < 1)) {

      // createNewSession();

      const ai_concierge_generate = document.getElementById('ai_concierge_generate');
      if (ai_concierge_generate) {
        ai_concierge_generate.click();
      }
    }
  }, [aiFormData]);

  useEffect(() => {
    isTimeRangeRef.current = isTimeRange;
  }, [isTimeRange]);

  const checkTime = async () => {
    try {
      const response = await fetch(`/auth/aiform/frontend/${client_url}`);

      const data = await response.json();
      if (!response.ok) {
        alert(`Error: ${data.message}`);
      } else {
        const aiForm = data.aiForms[0];

        const checkTime = filterCurrentDayAndCheckTime(aiForm?.weeklyTiming, aiForm?.timezone);

        if (!checkTime && isTimeRangeRef.current) {
          window.location.reload();
        }

        if (checkTime && !isTimeRangeRef.current) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Error fetching AI form data:', error);
    }
  };



  // -------------------------------
  const createNewSession = async () => {
    const res = await fetch("/api/create-session-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: aiFormData.user }),
    });
    const { session_token, session_id } = await res.json();
    setLoaderStart(true);
    setSkipSplashScreen(true);
    setIdealMode(false);

    console.log("Starting session with token:", session_id);


    await startSession(session_token);
    setSessionInfo({ session_id });

  };

  useEffect(() => {
    if (!isStreamReady) return;
    if (!mediaRef.current) return;

    const video = mediaRef.current;
    let revealed = false;
    let rafId;
    let timeoutId;

    attachElement(video);

    const reveal = () => {
      if (revealed) return;
      revealed = true;

      setMode(VIDEO_MODE.STREAM);
      startInactivityTimer();

      cleanup();
    };

    const checkFrame = () => {
      const stream = video.srcObject;
      if (!stream) return;

      const hasVideoTrack = stream.getVideoTracks().length > 0;

      // 🔑 Real frame condition
      if (
        hasVideoTrack &&
        video.videoWidth > 0 &&
        video.videoHeight > 0
      ) {
        reveal();
      }
    };

    const rafCheck = () => {
      checkFrame();
      if (!revealed) {
        rafId = requestAnimationFrame(rafCheck);
      }
    };

    const cleanup = () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };

    // 🔁 Start RAF-based detection (most reliable)
    rafCheck();

    // ⛑ HARD FAILSAFE (never get stuck)
    timeoutId = setTimeout(() => {
      console.warn("⚠️ Forcing STREAM mode (timeout fallback)");
      reveal();
    }, 1000); // 3s max wait

    return cleanup;
  }, [isStreamReady]);





  useEffect(() => {
    // ❌ Do nothing until media stream really starts
    if (!mediaStreamStartedRef.current) return;

    if (sessionState !== SessionState.CONNECTED) {
      clearInactivityTimer();
      return;
    }

    if (isAvatarTalking) {
      lastTalkingRef.current = Date.now();
      startInactivityTimer(); // reset
      return;
    }

    // silence countdown
    startInactivityTimer();

    return clearInactivityTimer;
  }, [isAvatarTalking, sessionState]);

  const startInactivityTimer = () => {
    clearInactivityTimer();

    inactivityTimerRef.current = setTimeout(async () => {
      console.warn("⏰ No HeyGen talking for 55s → stopping session");

      // setIsStreamReadyState(false);
      // setIdealMode(true);

      // // ✅ Reset refs
      // // videoRef.current = true;
      // // playInitialVideo.current = false;
      // setMode(VIDEO_MODE.LOOP);

      // // attachedRef.current = false;

      // setDisableSpeechButton(false);
      // setSessionInfo({});

      // safeStopSession()

    }, 55_000);
  };
  const clearInactivityTimer = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
      inactivityTimerRef.current = null;
    }
  };



  const safeStopSession = async () => {
    if (stoppingRef.current) return;
    stoppingRef.current = true;

    try {
      await stopSession();
    } finally {
      stoppingRef.current = false;
      attachedRef.current = false;
      ranOnceRef.current = false;
      streamActivatedRef.current = false;
    }
  };

  // -------------------------------
  // HANDLE DISCONNECT
  // -------------------------------
  useEffect(() => {
    console.log("🔍 DEBUG: sessionState changed to:", sessionState);
    
    if (sessionState === SessionState.DISCONNECTED) {
      console.log("🔌 Session disconnected");
      console.log("🔍 DEBUG: emitStateChange function exists?", !!emitStateChange);
      console.log("🔍 DEBUG: Calling emitStateChange('DISCONNECTED')");
      emitStateChange && emitStateChange('DISCONNECTED');

      setIsStreamReadyState(false);
      setIdealMode(true);

      // ✅ Reset refs
      // videoRef.current = true;
      // playInitialVideo.current = false;
      setMode(VIDEO_MODE.LOOP);
      attachedRef.current = false;

      setDisableSpeechButton(false);
      setSessionInfo({});

      safeStopSession();

    }
    if (sessionState === SessionState.CONNECTED) {
      console.log("Session connected");
    }

  }, [sessionState]);

  // -------------------------------
  // EMIT VIDEO MODE CHANGES TO BACKEND
  // -------------------------------
  useEffect(() => {
    console.log(`📹 Video mode changed to: ${mode}`);
    emitVideoMode && emitVideoMode(mode);
  }, [mode, emitVideoMode]);


  const reloadPage = () => {
    window.location.href = window.location.pathname + '?reload=' + new Date().getTime();
  };


  // On load Media Ref Play welcome Message
  useEffect(() => {
    const video = mediaRef.current;
    if (!video) return;

    const handleLoadedMetadata = async () => {
      if (!mediaRef.current) return;


      try {
        await video.play();

        // -------------------------
        // NON-RIZWAN AUTO WELCOME
        // -------------------------
        if (
          aiFormData.enable_rizwan_event !== 'yes' &&
          aiFormData.enable_face_detection !== 'yes' &&
          !waitingTime
        ) {
          await welcomemsg(sessionInfo.session_id);
          setDisableSpeechButton(true);
        }

        // -------------------------
        // FACE DETECTION CASE
        // -------------------------
        if (
          isInRangeRef.current &&
          aiFormData?.enable_face_detection === 'yes' &&
          !idealMode
        ) {
          await welcomemsg(sessionInfo.session_id);
        }

        // -------------------------
        // AUTO START LISTENING
        // -------------------------
        if (
          aiFormData.enable_rizwan_event !== 'yes' &&
          aiFormData.enable_face_detection !== 'yes' &&
          waitingTime
        ) {
          setWaitingTime(false);

          const aiStartTalk = document.getElementById('ai_starttalk');
          aiStartTalk && (aiStartTalk.style.display = 'none');

          const listenWord = UseTranslationData(aiFormData, 'en');
          if (
            aiFormData?.isButtonSelectMsgOn &&
            listenWord?.button_select_message
          ) {
            const text = getRandomMessage(listenWord.button_select_message);
            await repeat(sessionInfo.session_id, text, false);
            setTimeout(startButton, 3000);
          } else {
            startButton();
          }
        }
      } catch (err) {
        console.error("Autoplay failed:", err);
      }
    };

    const handleEnded = () => {
      console.log("Live stream speaking done");
      handleAvatarSpeechDone();
    };

    const startButton = () => {
      const btn = document.getElementById("ai_starttalk");
      btn && btn.click();
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);
    video.addEventListener("ended", handleEnded);

    return () => {
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
      video.removeEventListener("ended", handleEnded);
    };
  }, [
    sessionInfo?.session_id,     // stream identity
    aiFormData,
    idealMode,
    waitingTime
  ]);


  const handleAvatarSpeechDone = () => {
    // This function will be called when the live stream ends
    console.log('Avatar live stream has finished speaking.');
    // You can perform any action here
    // For example, reset a state, start a new session, or update the UI
  };

  const welcomemsg = async (sessionID, rizwanStatus = false) => {
    if (idealMode) {
      const ai_concierge_generate = document.getElementById('ai_concierge_generate');
      if (ai_concierge_generate) {
        ai_concierge_generate.click();
      }
      cancelFollowUp();

      setSessionInfo({});

      return;
    }


    // const predefinedText = rizwanStatus
    //   ? 'Hi Rizwan, welcome to our branch, how can I help you?'
    //   : translationData.avtar_welcome_text;

    const predefinedText = getRandomMessage(translationData.avtar_welcome_text);

    await repeat(sessionID, predefinedText, true, true, true);
    // setStartSpeech(!startSpeech);
    if (rizwanStatus) {
      setRizwanScriptStep(prevStep => prevStep + 1);
    }
  };

  // Initialize audio context to handle browser autoplay restrictions
  const initializeAudioContext = useCallback(async () => {
    try {
      // Create audio context if it doesn't exist
      if (!window.audioContext) {
        window.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      }
      
      // Resume audio context if suspended (browser autoplay policy)
      if (window.audioContext.state === 'suspended') {
        await window.audioContext.resume();
        console.log('✅ Audio context resumed');
      }
    } catch (error) {
      console.error('❌ Error initializing audio context:', error);
    }
  }, []);

  const repeat = async (session_id, text, action = false, disable = false, silence = false) => {
    const default_lang = localStorage.getItem('default_lang') || 'en';

    // Initialize audio context before speaking to handle browser autoplay restrictions
    await initializeAudioContext();

    let translatedText;
    if (!action) {
      translatedText = text || 'Thank you for your question.';
    } else {
      let google_speech_error_data =
        translationData?.google_speech_error ||
        'Sorry I cant able to hear you can you speak again?';
      const google_speech_error_text = getRandomMessage(google_speech_error_data);
      translatedText = text || google_speech_error_text;
    }


    console.log('Request payload:', translatedText);

    try {
      // Check if session exists
      if (!sessionRef.current) {
        console.error('No active session - cannot speak');
        showWarningToast('Session disconnected. Please wait while we reconnect...');

        // Reset disable button
        setDisableSpeechButton(false);

        return null;
      }

      // Send text using LiveKit
      const result = await sessionRef.current.repeat(translatedText)

      // Ensure video element audio is enabled
      if (mediaRef.current) {
        mediaRef.current.muted = false;
        mediaRef.current.volume = 1.0;
        console.log('✅ Video audio enabled - muted:', mediaRef.current.muted, 'volume:', mediaRef.current.volume);
      }

      console.log('Speak result:', sessionRef.current);

      const durationInMilliseconds = (result?.duration_ms || 3000) + 1000;


      // FaceDetection Case
      if (
        aiFormData.enable_rizwan_event !== 'yes' &&
        aiFormData.enable_face_detection === 'yes' &&
        action &&
        isInRangeRef.current
      ) {
        setTimeout(() => {
          onAvatarSpeakingDone();
        }, durationInMilliseconds);
      }

      // Reset disable button state after response
      setTimeout(() => {
        if (disable) {
          setDisableSpeechButton(false);

          // Auto-listen feature - but NOT when voice detection is active
          if (
            aiFormData?.enable_auto_speech_response &&
            !idealMode && !silence &&
            aiFormData.enable_face_detection !== 'yes' &&
            aiFormData?.enable_voice_detection !== 'yes'
          ) {
            setStartAutoButtonSpeech(true);
          }
        }
      }, durationInMilliseconds);

      return result;
    } catch (error) {
      console.error('Error in repeat function:', error);

      // Fallback: show error message to user
      showWarningToast('Failed to get avatar response. Please try again.');

      // Reset disable button on error
      setDisableSpeechButton(false);

      return null;
    }
  };

  // Update the repeatRef whenever the repeat function changes
  // This allows useWebSocketControl to access the latest repeat function
  useEffect(() => {
    repeatRef.current = repeat;
  }, [repeat]);


  const onAvatarSpeakingDone = () => {
    if (
      aiFormData.enable_rizwan_event === 'yes' &&
      (rizwanScriptStepRef.current === 3 || rizwanScriptStepRef.current === 4)
    ) {
      console.log('Avatar finished speaking, perform actions here.');
      // showSuccessToast('Please Speak Now!');
      setStartSpeech(true);
    }

    if (
      aiFormData.enable_rizwan_event !== 'yes' &&
      aiFormData.enable_face_detection === 'yes' &&
      isInRangeRef.current
    ) {
      setFaceDetectionStartSpeech(true);
    }

  };

  const startConverting = ses => {
    console.log('start talk', ses);
    setDisableSpeechButton(true);
    if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection !== 'yes') {
      document.getElementById('ai_starttalk').style.display = 'none';
      document.getElementById('stoprecording').style.display = 'block';
    }
  };

  const stopRecording = async (liveStreamText, languageCode, micLanguage = 'en-US') => {
    if (!aiFormData) {
      console.error('aiFormData is not available');
      return;
    }

    // Check if session is still active
    if (!sessionRef.current || !sessionInfo?.session_id) {
      console.error('No active session - cannot process recording');
      showWarningToast('Session disconnected. Please wait while we reconnect...');
      setDisableSpeechButton(false);
      return;
    }

    console.log('Stop recording:', liveStreamText);

    if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection !== 'yes') {
      document.getElementById('ai_starttalk').style.display = 'flex';
      document.getElementById('stoprecording').style.display = 'none';
    }

    const transaltionSpeechLive = UseTranslationData(aiFormData, languageCode);

    if (aiFormData.enable_rizwan_event !== 'yes') {
      setTranslationData(transaltionSpeechLive);
    }

    // Check if user actually spoke something
    if (!liveStreamText || liveStreamText.trim().length === 0) {
      console.warn('No speech detected');
      setDisableSpeechButton(false);
      return;
    }

    let prompt;

    if (aiFormData?.llm_option === 'motive') {
      prompt = `${liveStreamText}`.trim();
    } else {
      prompt = `${liveStreamText}`.trim();
    }

    let flag = false;

    // Rizwan Event validation
    if (aiFormData.enable_rizwan_event === 'yes') {
      if (numberRef.current.includes(rizwanScriptStep)) {
        console.error('Sorry this step already exists');
        setDisableSpeechButton(false);
        return;
      }

      // Handle Rizwan script steps
      if (rizwanScriptStep === 2) {
        prompt = "Svāgata chē!,, Mēṁ ēmīnē jaṇāvī dīdhuṁ chē.,, Śuṁ huṁ tamanē bījī kō'ī bābatamāṁ madada karī śakuṁ?";
        flag = true;
        rizwanScriptStepEnglishRef.current = null;
      } else if (rizwanScriptStep === 3) {
        prompt = "Oh, that's fantastic, did you know your advisor Amy, is also an avid traveler! One of our associates, directly behind me and to your right, would be happy to help you get up to 1000 Euros today. The current wait time is less than 5 minutes. Anything else you need assistance with?";
        flag = true;
        rizwanScriptStepEnglishRef.current = null;
      } else if (rizwanScriptStep === 4) {
        prompt = 'Happy to help, Amy will be with you shortly, Have a great rest of your evening.';
        flag = true;
        rizwanScriptStepEnglishRef.current = null;
      }
    }

    if (liveStreamText) {
      console.log('User transcript:', liveStreamText);

      let cases = aiFormData.enable_rizwan_event === 'yes' ? 'Rizwan Event' : 'Non Rizwan Event';

      let logId = await recordLog(prompt, liveStreamText, 'pending', cases, micLanguage);

      setDisableSpeechButton(true);

      try {
        if (aiFormData.enable_rizwan_event !== 'yes') {
          // Non-Rizwan case: Get AI response

          //////////////------------New ------------////////////////
          let beforeResponseText =
            transaltionSpeechLive?.before_response_text || "";

          if (beforeResponseText !== "") {
            const predefinedText = getRandomMessage(beforeResponseText);

            console.log("Playing before response text:", predefinedText);

            // Play before response message
            await repeat(sessionInfo.session_id, predefinedText, false, false);
          }
          ////////////////////////////////////////////////////////////////////////


          // Play before response message
          // await repeat(sessionInfo.session_id, predefinedText, false, false);

          let text;

          // Get response from selected LLM
          if (aiFormData?.llm_option === 'python') {
            text = await runPythonScript(prompt, logId);
          } else if (aiFormData?.llm_option === 'motive') {
            text = await runMotiveAIScript(prompt, logId, micLanguage);
          } else {
            text = await talkToOpenAI(prompt, logId);
          }

          console.log("text", text)

          await repeat(sessionInfo.session_id, text, true, true);


          // if (text && text.trim().length > 0) {
          //   // Play the AI response
          //   await repeat(sessionInfo.session_id, text, true, true);
          // } else {
          //   console.error('No response received from LLM');
          //   setDisableSpeechButton(false);
          //   showWarningToast('Failed to get response. Please try again.');
          // }
        } else {
          // Rizwan Event case
          numberRef.current.push(rizwanScriptStepRef.current);
          await repeat(sessionInfo.session_id, prompt, false, false);

          updateLog(liveStreamText, 'success', 'Rizwan Event', prompt, logId);

          if (flag) {
            setRizwanScriptStep(prevStep => prevStep + 1);
          }
        }
      } catch (error) {
        console.error('Error in stopRecording:', error);
        showWarningToast('Error processing your request. Please try again.');
        setDisableSpeechButton(false);
      }
    }
  };


  const getRandomMessage = inputString => {
    // const messages = inputString.split('|');
    // const trimmedMessages = messages.map(message => message.trim());
    // const randomIndex = Math.floor(Math.random() * trimmedMessages.length);
    // return trimmedMessages[randomIndex];

    if (!inputString || typeof inputString !== 'string') return '';
    // If there's no '|' just return the trimmed string
    if (inputString.indexOf('|') === -1) return inputString.trim();

    const messages = inputString
      .split('|')
      .map(message => message.trim())
      .filter(Boolean);

    if (messages.length === 0) return '';
    if (messages.length === 1) return messages[0];

    const randomIndex = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  };

  const talkToOpenAI = async (prompt, logId) => {
    const userId = aiFormData?.user;
    let cases = aiFormData.enable_rizwan_event === 'yes' ? 'Rizwan Event' : 'Non Rizwan Event';
    const response = await fetch(`/openai/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt, userId, session_id: sessionInfo.session_id, client_url }),
    });
    if (response.status === 500) {
      console.error('Server error');
      updateLog(prompt, 'failed', cases, 'error', logId, 'error');
    } else {
      const data = await response.json();

      updateLog(prompt, 'success', cases, data.text, logId);
      return data.text;
    }
  };

  const recordLog = async (prompt, userInput, status, casee, aiResponse = null, error = null, micLanguage = 'en-US') => {
    const userId = aiFormData?.user;
    casee = aiFormData?.llm_option || 'openai';
    const sessionId = sessionInfo.session_id;

    const response = await fetch(`/save-log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        client_url,
        userInput,
        prompt,
        aiResponse,
        status,
        error,
        casee,
        sessionId,

        micLanguage
      }),
    });
    if (response.status === 500) {
      console.error('Server error');
    } else {
      const data = await response.json();
      return data.logId;
    }
  };

  const updateLog = async (prompt, status, casee, aiResponse, logId, error = null) => {
    const userId = aiFormData?.user;

    casee = aiFormData?.llm_option || 'openai';

    const response = await fetch(`/update-log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, client_url, prompt, aiResponse, status, error, casee, logId }),
    });
    if (response.status === 500) {
      console.error('Server error');
    } else {
      const data = await response.json();
      return data.logId;
    }
  };


  // Hyegn Log report

  useEffect(() => {
    if (sessionInfo.session_id) {
      let intervalId;

      const submitHyegnReport = async () => {
        try {
          const userId = aiFormData?.user;
          const res = await fetch(
            `/api/heygen/${sessionInfo.session_id}/${client_url}/${userId}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );
          const data = await res.json();

          // console.log('submit hygen mints', data);
        } catch (err) {
          console.error('Error fetching Heygen report:', err);
        }
      };

      // Run immediately and then every 2 seconds
      submitHyegnReport();
      intervalId = setInterval(submitHyegnReport, 60000);



      // Cleanup on unmount
      return () => clearInterval(intervalId);
    }
  }, [isStreamReady, sessionInfo]);

  const playPromoMessage = async sessionID => {
    // alert("dsfdsf")
    const rizwanStatus = aiFormData.enable_rizwan_event === 'yes' ? true : false;

    // if(aiFormData.enable_face_detection==='yes' && !isInRangeRef.current){

    //   const disconnectavtar = document.getElementById("disconnectavtar");
    //   if (disconnectavtar) {
    //     disconnectavtar.click();
    //   }

    //   return
    // }

    if (translationData && !rizwanStatus) {
      let promoMessages = translationData.promo_message;
      const promoMessage = getRandomMessage(promoMessages);

      console.log('promoMessage', promoMessage);

      await repeat(sessionID, promoMessage);
    }
    // Implement your avatar speaking the promo message here
    // Example: await repeat(sessionInfo.session_id, promoMessage);
  };

  const runPythonScript = async (query, logId) => {
    try {
      let cases = aiFormData.enable_rizwan_event === 'yes' ? 'Rizwan Event' : 'Non Rizwan Event';
      const response = await fetch(`https://py.holomedia.ai/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        console.error('Server error');
        updateLog(query, 'failed', cases, 'Server error', logId, 'error');
        throw new Error('Server error');
      }

      const data = await response.json();
      if (data.success && data.text) {
        updateLog(query, 'success', cases, data.text, logId);
      } else {
        updateLog(query, 'failed', cases, data.text, logId, data.error);
      }

      return data.text ? data.text : 'Sorry no response found from python script please try again.';
    } catch (error) {
      console.error('Error in startSession:', error);
    }
  };

  const runMotiveAIScript = async (query, logId, micLanguage) => {
    try {
      let cases = 'motiveai';

      const requestData = {
        user: aiFormData.user,
        query,
        micLanguage,
      };

      const result = await axios.post('/api/motive', requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      await updateLog(query, 'success', cases, result.data.outputs[0].text, logId);

      return result.data.outputs[0].text;
    } catch (error) {
      console.error('Error in startSession:', error.message);

      showWarningToast(error.message);
      await updateLog(query, 'failed', 'motiveai', 'error', logId, error.message);
    }
  };


  const playUserSilenceMsg = async sessionID => {
    const rizwanStatus = aiFormData.enable_rizwan_event === 'yes' ? true : false;

    if (translationData && !rizwanStatus) {
      let promoMessages =
        translationData?.user_not_speak_text || 'How can I help you please speak Anything';
      const promoMessage = getRandomMessage(promoMessages);


      // if (aiFormData?.enable_auto_speech_response && !idealMode) {
      //   flag = false;
      // }


      await repeat(sessionID, promoMessage, true, true, true);
    }
    // Implement your avatar speaking the promo message here
    // Example: await repeat(sessionInfo.session_id, promoMessage);
  };

  const playRandomSpeech = async sessionID => {
    const rizwanStatus = aiFormData.enable_rizwan_event === 'yes' ? true : false;

    if (translationData && !rizwanStatus) {
      let promoMessages =
        translationData?.user_mic_random_message || 'Sorry! I cant hear you can please speak again';
      const promoMessage = getRandomMessage(promoMessages);

      console.log('playRandomSpeech', promoMessage);

      await repeat(sessionID, promoMessage, true);
    }
  };

  const disconnectSession = async () => {
    try {

      console.log("🔌 Session disconnecting");
      console.log("🔍 DEBUG: emitStateChange function exists?", !!emitStateChange);
      console.log("🔍 DEBUG: Calling emitStateChange('DISCONNECTED')");
      emitStateChange && emitStateChange('DISCONNECTED');

      setIsStreamReadyState(false);
      setIdealMode(true);

      // ✅ Reset refs
      // videoRef.current = true;
      // playInitialVideo.current = false;
      setMode(VIDEO_MODE.LOOP);
      attachedRef.current = false;

      setDisableSpeechButton(false);
      setSessionInfo({});

      // ✅ HARD RESET video element
      if (mediaRef.current) {
        const video = mediaRef.current;

        try {
          video.pause();

          // ✅ Remove playsinline (auto-added earlier)
          video.removeAttribute("playsinline");
          video.playsInline = false; // iOS Safari safety

          // ✅ Fully detach stream
          video.removeAttribute("src");
          video.srcObject = null;

          video.load();
        } catch (err) {
          console.warn("Video reset error:", err);
        }
      }

      // ✅ Stop session LAST (prevents race conditions)
      stopSession();


    } catch (error) {
      console.error('Error disconnecting session:', error);
    } finally {
      handleAvatarStopped();
    }
  };

  const handleAvatarStopped = () => {
    console.log("🛑 Avatar stopped");

    document.body.classList.remove("hide");


    setIsAvatarVisible(false);
    setIdealMode(true);
    setDisableSpeechButton(false);
    // setIsStreamReady(false);

    avatarSessionRef.current = null;
  };


  // Function to run after a delay
  const followUpAction = () => {
    console.log('Follow-up action executed after delay.');
    //window.location.reload();
    // Add your desired follow-up logic here
  };

  // Function to schedule the follow-up action
  const scheduleFollowUp = () => {
    setLoopSessionData(client_url, { idealMode: true });

    const delay = aiFormData?.loop_reset_time * 60 * 1000; // Delay in milliseconds (5 minutes)
    console.log(`Follow-up action scheduled in ${delay / 1000} seconds.`);

    timeoutIdRef.current = setTimeout(() => {
      followUpAction();
    }, delay);

    const camerarest = 2 * 60 * 1000;

    resetCameraRef.current = setInterval(() => {
      setKey(prevKey => prevKey + 1); // Increment the key to force re-render
    }, camerarest); // Update every 5 seconds (adjust as needed)
  };

  // Function to cancel the scheduled follow-up
  const cancelFollowUp = () => {
    clearTimeout(timeoutIdRef.current); // Cancel the timeout
    timeoutIdRef.current = null;
    unsetLoopSessionData(client_url);

    clearTimeout(resetCameraRef.current);
    resetCameraRef.current = null;

    console.log('Follow-up action cancelled.');
  };

  const resetPage = () => {
    window.location.href = window.location.pathname + '?reload=' + new Date().getTime();
  };

  // Function to get current day in EST
  const getCurrentDayInEST = (time_zone = 'America/New_York') => {
    const timeZone = time_zone; // EST/EDT Time Zone

    // Get the current UTC time
    const currentUtcDate = new Date();

    // Convert UTC time to EST/EDT time
    const zonedDate = toZonedTime(currentUtcDate, timeZone);

    // Format to get the day name (e.g., "Monday", "Tuesday")
    return format(zonedDate, 'EEEE', { time_zone }); // 'EEEE' returns full weekday name
  };

  // Function to check if current time is in the range
  const isCurrentTimeInRange = (startTime, endTime, time_zone = 'America/New_York') => {
    const timeZone = time_zone; // EST/EDT Time Zone

    // Get the current UTC time and convert it to EST
    const currentUtcDate = new Date();
    const currentZonedDate = toZonedTime(currentUtcDate, time_zone);

    // Parse the startTime and endTime as EST time
    const startTimeInEST = parse(startTime, 'HH:mm', currentZonedDate, { timeZone });
    const endTimeInEST = parse(endTime, 'HH:mm', currentZonedDate, { timeZone });

    // Check if the current time is within the range
    return currentZonedDate >= startTimeInEST && currentZonedDate <= endTimeInEST;
  };

  // Function to filter weekly timing and check if current time is in range
  const filterCurrentDayAndCheckTime = (weeklyTiming, time_zone = 'America/New_York') => {
    // console.log("weeklyTiming",weeklyTiming)
    const currentDay = getCurrentDayInEST(time_zone);

    // Find the timing for the current day
    const currentDayTiming = weeklyTiming?.find(item => item?.day === currentDay && item?.isOpen);

    if (!currentDayTiming) return null; // If no open timing for today, return null

    const isfullDay = weeklyTiming?.find(
      item => item?.day === currentDay && item?.isOpen && item?.isFullDay
    );
    if (isfullDay) return true;

    const { startTime, endTime } = currentDayTiming;

    // Check if current time is within the range of start and end times
    const isInRange = isCurrentTimeInRange(startTime, endTime, time_zone);

    return isInRange;
  };

  const resetLoopVideoBtnCase = async () => {
    if (idealMode) {
      setDisableSpeechButton(true);
      cancelFollowUp();
      setSkipSplashScreen(true);
      setIdealMode(false);


      setWaitingTime(!waitingTime);

      const ai_concierge_generate = document.getElementById('ai_concierge_generate');
      if (ai_concierge_generate) {
        ai_concierge_generate.click();
      }

      setSessionInfo({});

      return;
    }
  };

  const setLoopSessionData = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value)); // Convert to JSON for non-string values
  };

  const getLoopSessionData = key => {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null; // Parse JSON if it exists
  };

  const unsetLoopSessionData = key => {
    sessionStorage.removeItem(key);
  };


  useEffect(() => {
    const loadVideoUrl = async () => {
      // Wait until aiFormData is fully loaded and has the necessary properties
      if (!aiFormData || aiFormData.custom_looping_video === undefined) {
        console.log('aiFormData not ready yet, skipping video load');
        return;
      }

      let url;

      console.log('=== DEBUG VIDEO URL ===');
      console.log('custom_looping_video:', aiFormData.custom_looping_video);
      console.log('Type:', typeof aiFormData.custom_looping_video);
      console.log('looping_video_url:', aiFormData.looping_video_url);

      if (aiFormData.custom_looping_video === true) {
        console.log('✅ Using CUSTOM looping video');
        url = aiFormData.looping_video_url;
      } else {
        console.log('🔄 Fetching DEFAULT avatar video from API');
        try {
          const response = await fetch(`/api/api-keys/get-api-keys/avtar_key/${aiFormData.avtar_key_id}`);
          const data = await response.json();

          url = data?.avatarLoopVideo ? data.avatarLoopVideo : aiFormData.looping_video_url;
          console.log('API response URL:', url);
        } catch (error) {
          console.error('Error fetching video URL:', error);
          url = aiFormData.looping_video_url;
        }
      }

      console.log('🎬 Final video URL:', url);
      setLoopingVideoUrl(url);
    };

    const loadBeforeAvatarVideoUrl = async () => {
      if (aiFormData && aiFormData.before_avatar_video !== undefined) {
        setBeforeAvatarVideo(aiFormData.before_avatar_video);
        // switchVideoMode(VIDEO_MODE.INITIAL);
      }
    };

    // Only load after aiFormData is ready
    if (aiFormData && aiFormData.custom_looping_video !== undefined) {
      setTimeout(() => {
        loadVideoUrl();
      }, 5000);
    }

    loadBeforeAvatarVideoUrl()

  }, [aiFormData]);



  if (!isAvatarVisible && !aiFormData && !loopingVideoUrl) {
    return (
      <>
        <div>Loading...</div>
      </>
    );
  } else {
    return (
      <div className="main">
        <div className="videoSectionWrap"
          id="sec1"
          style={{ display: idealMode ? 'none' : '', cursor: "pointer" }}
          onClick={() => createNewSession()}
        >


          {(!isTimeRange || !skipSplashScreen) && <MainImageLogo />}

          <div className="ai_concierge">
            <button
              type="button"
              className="ai_concierge"
              id="ai_concierge_generate"
              style={{ backgroundColor: 'unset', display: !skipSplashScreen ? 'block' : 'none' }}

            >
              <SplashTextAIHuman
                text={translationData?.home_screen_btn_text1 || 'Please touch to start'}
                settings={userBrandSettings}
              />
            </button>
          </div>

          {handleLiveChatVisibility(aiFormData, translationData)}

          <div className="language_sec" id="language_sec" style={{ display: 'none' }}>
            {renderLanguageButtons()}
          </div>
        </div>

        <p id="status" style={{ display: 'none' }} />

        <button id="disconnectavtar" style={{ display: 'none' }} onClick={disconnectSession}>
          Disconnect Avatar
        </button>

        <div
          className="videoSectionWrap avtarsection"
          style={{ display: 'flex' }} // Set the display dynamically
        >




          {sessionInfo && skipSplashScreen && (
            <div className="videoWrap">
              {/* ---------------- BUBBLE OVERLAY ---------------- */}

              <BubblesIntegration aiFormData={aiFormData} disableSpeechButton={disableSpeechButton} />

              <HeaderLogo
                styles={positionAvatarLogo(aiFormData?.avtar_page_image_location)}
                onClick={resetPage}
              />

              {/* Avatar SDK Streaming Video */}


              <div className="video-stage">
                {/* INITIAL */}
                <video
                  ref={initialVideoRef}
                  className={`video ${mode === VIDEO_MODE.INITIAL ? "show" : "hide"}`}
                  src={beforeAvatarVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                />

                {/* LOOP */}
                <video
                  ref={loopVideoRef}
                  className={`video ${mode !== (VIDEO_MODE.STREAM && !VIDEO_MODE.INITIAL) ? "show" : "hide"}`}
                  src={loopingVideoUrl}
                  autoPlay
                  muted
                  loop
                  playsInline
                />

                {/* STREAM */}
                <video
                  ref={mediaRef}
                  className={`video ${mode === VIDEO_MODE.STREAM ? "show" : "hide"}`}
                  autoPlay
                  playsInline
                  muted={false}
                  volume={1.0}
                  />
                    
              </div>


              <div className="imagebuttons">
                {isTimeRange && !websocketEnabled && aiFormData?.speech_tool === 'google' && (
                  <AudioToText
                    siteBrandColor={siteBrandColor}
                    onstartConverting={startConverting}
                    onstopRecording={stopRecording}
                    translationData={translationData}
                    aiFormData={aiFormData}
                    onplayPromoMessage={playPromoMessage}
                    onsessionInfo={sessionInfo?.session_id}
                    // onSpeechRecognitionEnd={(text) => console.log("Final text:", text)}
                    onstartspeech={startSpeech}
                    rizwanScriptStep={rizwanScriptStep}
                    setonstartspeech={() => setStartSpeech(!startSpeech)}
                    rizwanScriptStepEnglishRef={rizwanScriptStepEnglishRef.current}
                    rizwanButtonFun={welcomemsg}
                    onfaceDetectionStartSpeech={faceDetectionStartSpeech}
                    setfaceDetectionStartSpeech={() =>
                      setFaceDetectionStartSpeech(!faceDetectionStartSpeech)
                    }
                    isInRangeRefFun={isInRangeRef.current}
                    onplayUserSilenceMsg={playUserSilenceMsg}
                    playRandomSpeech={playRandomSpeech}
                    idealMode={idealMode}
                    resetLoopVideoBtnCase={resetLoopVideoBtnCase}
                    waitingTime={waitingTime}
                    disableSpeechButton={disableSpeechButton}
                    startAutoButtonSpeech={startAutoButtonSpeech}
                    setStartAutoButtonSpeech={() => setStartAutoButtonSpeech(false)}
                  />
                )}

                {isTimeRange && !websocketEnabled && aiFormData?.speech_tool === 'javascript' && (
                  <AudioToTextJavaScript
                    siteBrandColor={siteBrandColor}
                    onstartConverting={startConverting}
                    onstopRecording={stopRecording}
                    translationData={translationData}
                    aiFormData={aiFormData}
                    onplayPromoMessage={playPromoMessage}
                    onsessionInfo={sessionInfo?.session_id}
                    // onSpeechRecognitionEnd={(text) => console.log("Final text:", text)}
                    onstartspeech={startSpeech}
                    rizwanScriptStep={rizwanScriptStep}
                    setonstartspeech={() => setStartSpeech(!startSpeech)}
                    rizwanScriptStepEnglishRef={rizwanScriptStepEnglishRef.current}
                    rizwanButtonFun={welcomemsg}
                    onfaceDetectionStartSpeech={faceDetectionStartSpeech}
                    setfaceDetectionStartSpeech={() =>
                      setFaceDetectionStartSpeech(!faceDetectionStartSpeech)
                    }
                    isInRangeRefFun={isInRangeRef.current}
                    onplayUserSilenceMsg={playUserSilenceMsg}
                    playRandomSpeech={playRandomSpeech}
                    idealMode={idealMode}
                    resetLoopVideoBtnCase={resetLoopVideoBtnCase}
                    waitingTime={waitingTime}
                    disableSpeechButton={disableSpeechButton}
                    startAutoButtonSpeech={startAutoButtonSpeech}
                    setStartAutoButtonSpeech={() => setStartAutoButtonSpeech(false)}
                  />
                )}

                {isTimeRange && websocketEnabled && aiHumanWebsocketUrl && isStreamReady && sessionInfo?.session_id && !idealMode && (
                  <WebSocketIframe
                    url={aiHumanWebsocketUrl}
                    brandColor={siteBrandColor}
                    styles={iframeStyles}
                  />
                )}

                {aiFormData?.enable_voice_detection === 'yes' && isTimeRange && (
                  <VoiceDetection
                    onsessionInfo={sessionInfo?.session_id}
                    styles={positionAvatarLogo(aiFormData?.face_detection_location)}
                    aiFormData={aiFormData}
                    isInRangeRef={isInRangeRef}
                    disableSpeechButton={disableSpeechButton}
                    isAvatarTalking={isAvatarTalking}
                    onCreateSession={createNewSession}
                  />
                )}

                {aiFormData?.enable_face_detection === 'yes' && isTimeRange && (
                  <FaceDetection
                    key={key} // Force re-render when the key changes
                    onplayPromoMessage={welcomemsg}
                    onsessionInfo={sessionInfo?.session_id}
                    onstartspeech={() => {
                      setStartSpeech(!startSpeech);
                    }}
                    styles={positionAvatarLogo(aiFormData?.face_detection_location)}
                    aiFormData={aiFormData}
                    rizwanScriptStep={rizwanScriptStep}
                    isInRangeRef={isInRangeRef}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {
          aiFormData.enable_rizwan_event === 'yes' && showButton && (
            <div id="back_to_menu">
              <button
                type="button"
                style={{ fontSize: '42px' }}
                onClick={() =>
                  sessionInfo?.session_id && isAvatarVisible ? reloadPage() : createNewSession()
                }
              >
                <i className={`fa fa-refresh ${loaderStart && !isAvatarVisible ? 'fa-spin' : ''}`} />
              </button>
            </div>
          )
        }

        {
          isAvatarVisible && (
            <div className="copyright_section" style={{ cursor: 'pointer' }} onClick={reloadPage}>
              <span
                id="footer_text_copyright"
                style={{
                  backgroundColor: translationData?.welcom_text_back_color,
                  color: translationData?.welcom_text_color,
                }}
              >
                {' '}
                {translationData?.footer_text}
              </span>
            </div>

          )
        }
        <style>{`
                .video-stage {
                position: relative;
                width: 100%;
                height: 100%;
                background: #000;
              }

              .video-stage .video {
                position: absolute;
                inset: 0;
                width: 100%;
               
                object-fit: cover;

                opacity: 0;
                transition: opacity 180ms ease-out;
                pointer-events: none;
              }

              .video-stage .video.show {
                opacity: 1;
                z-index: 2;
              }

             .video-stage .video.hide {
                opacity: 0;
                z-index: 1;
              }

            `}</style>
      </div >
    );


  }
}


